module.exports = __webpack_public_path__ + "static/assets/5b6ce05dee0205417c067ad459c8d376.png";